import React from 'react';
import { connect } from 'react-redux';
import axios from '../config/axiosInstance';

const withToken = WrappedComponent =>
  connect(state => ({
    token: state.auth.token,
  }))(class extends React.Component {
    componentWillMount() {
      this.reqInterceptor = axios.interceptors.request.use((config) => {
        const request = { ...config };
        request.headers.Authorization = `Bearer ${this.props.token}`;
        return request;
      });
    }

    componentWillUnmount() {
      axios.interceptors.request.eject(this.reqInterceptor);
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  });

export default withToken;
